module.exports = __webpack_public_path__ + "img/favorites-active.6310bb8b.svg";